// Urls
export const ACCOUNT_CREATE_EDIT = "/v2/accounts";
export const ACCOUNT_BY_ACCOUNT_ID = "/v2/accounts/:accountId";
export const ACCOUNT_FORGOT_PASSWORD = "/v2/accounts/forgot-password";
export const ACCOUNT_RESET_PASSWORD = "/v2/accounts/reset-password";
export const VERIFY_ACCOUNT_BY_TOKEN = "/v2/accounts/verify-token";
export const VERIFY_ACCOUNT_AUTHORIZED_EVENT =
  "/v2/accounts/:accountId/events/:eventId";
export const ACCOUNT_LOGIN = "/v2/accounts/login";
export const STRETCH_FETCH_USER_PURCHASES = "/order/all";
export const STRETCH_FETCH_ORDER_DETAILS = "/order/id";
export const STRETCH_POST_EVENT_CONSUME = "/account/consume";

// Constants
export const CREATE_ACCOUNT = "CREATE_ACCOUNT";
export const CREATE_ACCOUNT_DONE = "CREATE_ACCOUNT_DONE";
export const CREATE_ACCOUNT_ERROR = "CREATE_ACCOUNT_ERROR";

export const EDIT_ACCOUNT = "EDIT_ACCOUNT";
export const EDIT_ACCOUNT_DONE = "EDIT_ACCOUNT_DONE";
export const EDIT_ACCOUNT_ERROR = "EDIT_ACCOUNT_ERROR";

export const GET_ACCOUNT_BY_ACCOUNT_ID = "GET_ACCOUNT_BY_ACCOUNT_ID";
export const GET_ACCOUNT_DONE = "GET_ACCOUNT_DONE";

export const LOGIN = "LOGIN";
export const LOGIN_DONE = "LOGIN_DONE";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const LOGIN_SSO = "LOGIN_SSO";
export const LOGOUT = "LOGOUT";

export const STORE_NEXT_URL = "STORE_NEXT_URL";
export const CLEAN_NEXT_URL = "CLEAN_NEXT_URL";

export const FETCH_AUTHORIZED_EVENT = "FETCH_AUTHORIZED_EVENT";
export const FETCH_AUTHORIZED_EVENT_DONE = "FETCH_AUTHORIZED_EVENT_DONE";
export const CLEAR_AUTHORIZED_EVENT = "CLEAR_AUTHORIZED_EVENT";

export const FETCH_USER_PURCHASES = "FETCH_USER_PURCHASES";
export const FETCH_USER_PURCHASES_DONE = "FETCH_USER_PURCHASES_DONE";
export const CLEAR_ORDER_HISTORY = "CLEAR_ORDER_HISTORY";

export const FETCH_ORDER_DETAILS = "FETCH_ORDER_DETAILS";
export const FETCH_ORDER_DETAILS_DONE = "FETCH_ORDER_DETAILS_DONE";
export const CLEAR_ORDER_DETAILS = "CLEAR_ORDER_DETAILS";

export const POST_CONSUME_EVENT = "POST_CONSUME_EVENT";

export const REQUEST_PASSWORD_RESET = "REQUEST_PASSWORD_RESET";
export const REQUEST_PASSWORD_RESET_DONE = "REQUEST_PASSWORD_RESET_DONE";
export const REQUEST_PASSWORD_RESET_ERROR = "REQUEST_PASSWORD_RESET_ERROR";

export const VERIFY_ACCOUNT_TOKEN = "VERIFY_ACCOUNT_TOKEN";
export const VERIFY_ACCOUNT_TOKEN_DONE = "VERIFY_ACCOUNT_TOKEN_DONE";
export const VERIFY_ACCOUNT_TOKEN_ERROR = "VERIFY_ACCOUNT_TOKEN_ERROR";

export const RESET_ACCOUNT_PASSWORD = "RESET_ACCOUNT_PASSWORD";
export const RESET_ACCOUNT_PASSWORD_DONE = "RESET_ACCOUNT_PASSWORD_DONE";
export const RESET_ACCOUNT_PASSWORD_ERROR = "RESET_ACCOUNT_PASSWORD_ERROR";
